// ProductQRList.js

import React, { Component } from 'react';
import { Button, Form, Container, Row, Col, ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import { JsonToExcel } from 'react-json-excel';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

// class RowItem extends Component {
//     static defaultProps = {
//         key: null,
//         item: null,
//         enable: false,
//         onPress: () => { },
//         onChange: () => { },
//     }
//     constructor(props) {
//         super(props);
//         this.state = {
//             item : this.props.item
//         };
//     }

//     componentWillReceiveProps(nextProps){
//         // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
//         this.setState( { 
//             item : nextProps.item
//         } );
//     }

//     handleRowClick = () => {
//         this.props.onPress(this.props.item);
//         event.preventDefault();
//     }

//     handleChangeEMAIL = () => {
//         var item = this.state.item;
//         item.EMAIL = event.target.value;
//         this.props.onChange( item );
//         event.preventDefault();
//     }

//     handleChangeUSE = () => {
//         var item = this.state.item;
//         item.USE_FLAG = event.target.value;
//         this.props.onChange( item );
//         event.preventDefault();
//     }

//     render(){
//         return (
//             <tr onClick={this.handleRowClick}>
//             <td>{this.props.item.ID}</td>
//             <td>{this.props.item.QRCODE}</td>
//             <td>
//                 {this.state.item.EMAIL} 
//             </td>
//             <td>
//                 {this.state.item.USE_FLAG}
//             </td>
//             {/* <td>
//                 <Form.Control type="title" placeholder="입력하세요." value={this.state.item.EMAIL} onChange={this.handleChangeEMAIL.bind(this)} />
//             </td>
//             <td>
//                 <Form.Control type="title" md="3" placeholder="입력하세요." value={this.state.item.USE_FLAG} onChange={this.handleChangeUSE.bind(this)} />
//             </td> */}
//             <td>{this.props.item.OLD_QR}</td>
//             </tr>
//         );
//     }
// };

const className = 'class-name-for-style',
    filename = 'PicturePurchase_Excel-file',
    fields = {
        "ID": "#",
        "QRCODE": "QR CODE",
        "CODE": "CODE",
        "EMAIL": "EMAIL",
        "USE_FLAG": "사용여부",
        "OLD_QR": "OLD_QR"
    },
    style = {
        padding: "5px",
        background: "#3c8dbc",
        border: "1px #367fa9",
        borderRadius: "3px",
        padding: "6px 12px",
        color: "#ffffff",
        font: "14px",
        height: "34px",
        verticalAlign: 'middle'
    }

export default class ProductQRList extends Component {
    static defaultProps = {
        item: null,
        images: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.timer = null;
        this.emptyItem = {
            ID: 0,
            PCODE: "0000",
            QRCODE: "",
            CODE: "",
            EMAIL: "",
            USE_FLAG: "",
            OLD_QR: ""
        }
        this.state = {
            FILE: '',
            rowlist: [],
            answervisible: false,
            enable: true,
            item: this.props.item,
            details: [],
            newQR: false
        };
    }

    componentWillReceiveProps(nextProps) {
        // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({ item: nextProps.item, images: nextProps.images });
        this.refreshGetInfo();
    }

    refreshGetInfo() {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.handleGetInfo(null);
        }, 500);
    }

    handleClose() {
        this.setState({ answervisible: false });
    }

    handleGetInfo(event) {
        Config.fetchData('productQR', {
            PCODE: this.state.item.PCODE
        }, (result, count) => {
            // console.log('productQR=', result);
            result.forEach(element => element.EMAIL = element.EMAIL ? element.EMAIL : "");
            this.setState({ details: result }, () => {
                this.handleChangeDetail();
            })
        }, true);
    }

    handleChangeDetail() {
        this.setState({ rowlist: this.state.details });
    }


    handleSubmit(event) {
        if (!this.state.newQR)
            return;

        var result = confirm("저장 하시겠습니까?");
        if (result) {

            this.setState({ newQR: false });


            var arrData = [];
            var list = this.state.rowlist;
            for (var i = 0; i < list.length; ++i) {
                arrData.push([list[i].PCODE, list[i].QRCODE, list[i].CODE])
            }

            Config.fetchData('insproductQR', {
                PCODE: this.state.item.PCODE,
                DATA: arrData
            }, (result, count) => {
                console.log('insproductQR=', count);
                if (count < 1) {
                    alert("QR 코드가 등록되지 않았습니다.\nQR목록을 확인해 주세요.\n(CODE가 없으면 등록되지 않습니다.)");
                } else {
                    alert(count + "개의 QR 코드 및 코드가 등록 되었습니다.")
                }
                this.refreshGetInfo();
            }, true);
        }
        event.preventDefault();
    }

    handleRemove(event) {
        var result = confirm("삭제 하시겠습니까?");
        if (result) {
            Config.fetchData('delproductQR', {
                PCODE: this.state.item.PCODE
            }, (result, count) => {
                console.log('delproductQR=', count);
                this.refreshGetInfo();
            }, true);
        }
        event.preventDefault();
    }

    handleGetFromS3(event) {
        Config.fetchData('getproductfiletext', {
            PCODE: this.state.item.PCODE,
            PATH: this.state.FILE
        }, (result, count) => {
            console.log('getproductfiletext=', result);
            var imagelist = [];
            for (var i = 1; i < result.length; ++i) {
                var arrQRnCode = result[i].split(',');
                var qrnum = arrQRnCode[0].trim();
                var code = arrQRnCode.length > 2 ? arrQRnCode[2].trim() : "";
                if (qrnum.length > 0) {
                    var item = { ...this.emptyItem };
                    item.ID = i;
                    item.PCODE = this.state.item.PCODE;
                    item.QRCODE = 'http://106.250.186.122/landing/landing?idx=' + qrnum;
                    item.CODE = code;
                    imagelist.push(item);
                }
            }

            if (imagelist.length > 0)
                this.setState({ newQR: true });

            this.setState({ rowlist: imagelist })
        }, true);
        event.preventDefault();
    }


    handleRowClick = () => {
        event.preventDefault();
    }

    handleChangeFILE(event) {
        this.setState({ FILE: event.target.value });
    }

    handleRowChange = (item) => {
        var row = this.state.rowlist;
        // row[item.ID] = item;
        // console.log( JSON.stringify( row ) );
        this.setState({ rowlist: row });
        event.preventDefault();
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const { rowCount } = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({ scrollToIndex });
    }

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    onClickRestore = (val) => {
        if (window.confirm(val + " 항목을 복원 하시겠습니까?")) {
            console.log("Confirmed!");
            Config.fetchData('restoreQR', {
                ID: val
            }, (result, count) => {
                console.log('restoreQR=', count);
                this.refreshGetInfo();
            }, true);
        }
    }

    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="box" >
                <div className="row" style={{ margin: 10 }}>
                    <div className="col-md-12">
                        <Button variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                        <Button variant="primary" onClick={this.handleGetFromS3.bind(this)}>S3에서 가져오기</Button>
                        {this.state.rowlist.length > 0 ?
                            <JsonToExcel
                                data={this.state.rowlist}
                                className={className}
                                filename={filename}
                                fields={fields}
                                style={style}
                            />
                            :
                            null
                        }
                        {/* <Button variant="primary" onClick={this.handleRemove.bind(this)}>삭제</Button> */}
                    </div>
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <div className="col-md-6">
                        <Form.Group as={Col} controlId="exampleForm.ControlInput1">
                            <Form.Label>상품코드</Form.Label>
                            <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.PCODE} />
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>QR 파일</Form.Label>
                            <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.FILE} onChange={this.handleChangeFILE.bind(this)} />
                            <Form.Control as="select" value={this.state.FILE} onChange={this.handleChangeFILE.bind(this)} onClick={this.handleChangeFILE.bind(this)}>
                                {this.props.images.map((item, index) =>
                                    <option>{item.name}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                    </div>
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <hr />
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <AutoSizer disableHeight>
                        {({ width }) => (
                            <Table
                                ref="Table"
                                headerClassName={'headerColumn'}
                                onRowClick={this.handleRowClick}
                                headerHeight={30}
                                height={500}
                                noRowsRenderer={this._noRowsRenderer}
                                overscanRowCount={10}
                                rowClassName={this._rowClassName}
                                rowHeight={40}
                                rowGetter={({ index }) => this.state.rowlist[index]}
                                rowCount={this.state.rowlist.length}
                                scrollToIndex={this.state.scrollToIndex}
                                width={width}>
                                <Column
                                    width={100}
                                    disableSort
                                    label="#"
                                    dataKey="ID"
                                    className={'exampleColumn'}
                                    cellRenderer={({ cellData }) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={700}
                                    disableSort
                                    label="QR CODE"
                                    dataKey="QRCODE"
                                    className={'exampleColumn'}
                                    cellRenderer={({ cellData }) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={500}
                                    disableSort
                                    label="CODE"
                                    dataKey="CODE"
                                    className={'exampleColumn'}
                                    cellRenderer={({ cellData }) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={500}
                                    disableSort
                                    label="EMAIL"
                                    dataKey="EMAIL"
                                    className={'exampleColumn'}
                                    cellRenderer={({ cellData }) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={100}
                                    disableSort
                                    label="사용"
                                    dataKey="USE_FLAG"
                                    className={'exampleColumn'}
                                    cellRenderer={({ cellData }) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={100}
                                    disableSort
                                    label="OLD"
                                    dataKey="OLD_QR"
                                    className={'exampleColumn'}
                                    cellRenderer={({ cellData }) => cellData}
                                    flexGrow={1}
                                />
                                <Column
                                    width={50}
                                    disableSort
                                    label="복원"
                                    dataKey="ID"
                                    className={'exampleColumn'}
                                    cellRenderer={({ cellData }) => <Button variant="primary" onClick={() => this.onClickRestore(cellData)}>복원</Button>}
                                    flexGrow={1}
                                />
                            </Table>
                        )}
                    </AutoSizer>
                    {/* <ScrollArea style={{  width: '100%' , height: 500 }}
                        className="area"
                        contentClassName="content"
                        verticalScrollbarStyle={scrollbarStyles}
                        verticalContainerStyle={scrollbarStyles}
                        horizontalScrollbarStyle={scrollbarStyles}
                        horizontalContainerStyle={scrollbarStyles}
                        smoothScrolling= {true}
                        minScrollSize={5}
                        onScroll={this.handleScroll}
                        >
                    <Table striped bordered hover>
                    <thead>
                        <tr>
                        <td>#</td>
                        <td>QR CODE</td>
                        <td>EMAIL</td>
                        <td>사용여부</td>
                        <td>OLD QR</td>
                        </tr>
                    </thead>
                    <tbody>

                    { this.state.rowlist.map((item, index) =>
                        <RowItem key={index} item={item} onPress={this.handleRowClick.bind(this)} onChange={this.handleRowChange.bind(this)}/>
                    )}

                    </tbody>
                    </Table>
                    </ScrollArea> */}
                </div>


            </div>

        );
    }
};





// WEBPACK FOOTER //
// src/components/ProductQRList.js